import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreateTestimonialAnonymousService = (data: FormData) => {
  return HTTP_CLIENT.post(
    `${Endpoint.testimonials.createTestimonialAnonymous}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const UpdateTestimonialAnonymousService = (
  testimonialId: number,
  payload: any
) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.testimonials.updateTestimonialAnonymous}/${testimonialId}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const GetTestimonialsService = () => {
  return HTTP_CLIENT.get(`${Endpoint.testimonials.getTestimonials}`);
};

const DeleteTestimonialService = (id: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.testimonials.deleteTestimonial}/${id}`);
};

export {
  CreateTestimonialAnonymousService,
  UpdateTestimonialAnonymousService,
  GetTestimonialsService,
  DeleteTestimonialService,
};
